export enum FixtureTypes {
  Regular = "REGULAR",
  Playoff = "PLAYOFF",
  Final = "FINAL",
  PreSeason = "PRESEASON",
  Friendly = "FRIENDLY",
  AllStar = "ALL_STAR",
  Demonstration = "DEMONSTRATION",
}
